import GamePlugin from 'app/src/plugins/GamePlugin';
import { createContext, useContext } from 'react';

type PluginsContext = Set<GamePlugin>;

const context = createContext<PluginsContext | null>(null);

export function usePluginsContext(): PluginsContext {
	const contextValue = useContext(context);

	if (contextValue === null) {
		throw new Error('usePluginsContext must be used within a PluginsContextProvider');
	}

	return contextValue;
}

export const PluginsContextConsumer = context.Consumer;
export const PluginsContextProvider = context.Provider;
